export default __webpack_public_path__ + "static/media/93.c150842c.png";